/****************************************************************************************
 * File Name    : ToolTemplateRegister.vue
 * Function     : 치공구외 신규등록 (템플릿 등록)
 * Author       : 
 * Description  : 치공구 점검 템플릿 생성 및 관리
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2026.02.17  	        	Create
****************************************************************************************/
<template>
    <div class="">
        <div v-if="flagSpinner === false">
            <a-row :gutter="16">
                <a-col class="gutter-row" :span="24">
                    <div class="gutter-box">
                        <PageHeader title="치공구 점검 템플릿 신규등록" />
                    </div>
                </a-col>
            </a-row>
            <a-divider type='horizontal' />
            
            <a-space align="end" style="padding-top:10px;">
                <a-radio-group v-model="filterState">
                    <a-radio-button @click="changeFilterState('등록중')" value="등록중">등록중만 보기</a-radio-button>
                    <a-radio-button @click="changeFilterState('등록완료')" value="등록완료">등록완료만 보기</a-radio-button>
                    <a-radio-button @click="changeFilterState('모두')" value="모두">모두보기</a-radio-button>
                </a-radio-group>
                <a-input placeholder="검색할 이름을 입력하세요" v-model="filterCS" />
                <a-button type="primary" :ghost="true" @click="filterCSList">검색</a-button>
                <a-button @click="resetCSList">초기화</a-button>
                <a-divider type='vertical' />
                <div class="border:1px solid red;width:100%">
                    <a-button type="primary" icon="plus-circle" size="default" @click="showCreateModal">
                        치공구 점검 템플릿 생성
                    </a-button>
                </div>
            </a-space>
            <p/>
            <a-progress type='line' :percent="validRate" strokeColor='#C7C6C6'/>
            <p/>
            
            <a-table :columns="columns" size="small" :bordered="false" :data-source="data" :pagination="pagination" :scroll="{ x: 0, y: '57vh' }" @change="handleTableChange">
                <span slot="tags" slot-scope="tag">
                    <a-tag class="state-btn" :class="{ red: (tag === '등록중'), green: (tag === '등록완료') }">
                        {{ tag.toUpperCase() }}
                    </a-tag>
                </span>
                <span slot="name" slot-scope="text">{{ text }}</span>
                <span slot="action" slot-scope="record">
                    <span style='cursor:pointer' @click="handlerToEdit(record.key)"><a-icon type="edit" /> Edit</span>
                    <a-divider type="vertical" />
                    <span style='cursor:pointer' @click="handlerToCopy(record.key)"><a-icon type="copy" /> 복사생성</span>
                    <a-divider type="vertical" />
                    <span style='cursor:pointer' @click="handlerToDelete(record.key)"><a-icon type="delete" /> Delete</span>
                    <a-divider type="vertical" />
                    <span style='cursor:pointer' @click="handlerToView(record.key)"><a-icon type="eye" /> View</span>
                </span>
            </a-table>
        </div>
        <a-skeleton v-else />

        <!-- 템플릿 생성/수정 Modal -->
        <a-modal
            v-model="isCreateModalVisible"
            :title="modalTitle"
            width="90%"
            :footer="null"
            @cancel="handleModalCancel"
        >
            <a-form :form="form" layout="vertical">
                <!-- 기본정보 -->
                <a-card title="기본정보" :bordered="false" style="margin-bottom: 16px;">
                    <a-row :gutter="16">
                        <a-col :span="6">
                            <a-form-item label="템플릿명">
                                <a-input v-model="formData.basicInfo.templateName" placeholder="템플릿명" :disabled="viewMode" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="라인명">
                                <a-input v-model="formData.basicInfo.lineName" placeholder="라인명" :disabled="viewMode" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="작성자명">
                                <a-input v-model="formData.basicInfo.writer" placeholder="작성자명" :disabled="viewMode" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="작성일자">
                                <a-input :value="formData.basicInfo.date" :read-only="true" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-card>

                <!-- 드라이버 토크 관리 -->
                <a-card title="드라이버 토크 관리" :bordered="false" style="margin-bottom: 16px;">
                    <!-- <div v-if="!viewMode" class="list-add-bar" style="margin-bottom: 16px;">
                        <a-button type="dashed" block @click="addDriverTorqueItem">
                            <a-icon type="plus" /> 항목 추가
                        </a-button>
                        <a-checkbox v-model="copyOnAdd.driverTorque">값 복사</a-checkbox>
                    </div> -->
                    <a-table 
                        :columns="driverTorqueColumns" 
                        :data-source="formData.driverTorque" 
                        :pagination="false"
                        size="small"
                        bordered
                    >
                        <template slot="no" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </template>
                        <template slot="processName" slot-scope="text, record">
                            <a-input v-model="record.processName" placeholder="공정명" :disabled="viewMode" />
                        </template>
                        <template slot="toolType" slot-scope="text, record">
                            <a-select v-model="record.toolType" style="width: 100%" :disabled="viewMode">
                                <a-select-option value="에어">에어</a-select-option>
                                <a-select-option value="전기">전기</a-select-option>
                                <a-select-option value="기타">기타</a-select-option>
                            </a-select>
                        </template>
                        <template slot="managementNo" slot-scope="text, record">
                            <a-input v-model="record.managementNo" placeholder="관리번호" :disabled="viewMode" />
                        </template>
                        <template slot="standard" slot-scope="text, record">
                            <a-input v-model="record.standard" placeholder="기준" :disabled="viewMode" />
                        </template>
                        <template slot="action" slot-scope="text, record, index">
                            <a-button v-if="!viewMode" type="link" size="small" @click="removeDriverTorqueItem(index)">
                                <a-icon type="delete" />
                            </a-button>
                            <span v-else>-</span>
                        </template>
                    </a-table>
                    <div v-if="!viewMode" class="list-add-bar" style="margin-top: 16px;">
                        <a-button type="dashed" block @click="addDriverTorqueItem">
                            <a-icon type="plus" /> 항목 추가
                        </a-button>
                        <a-checkbox v-model="copyOnAdd.driverTorque">값 복사</a-checkbox>
                    </div>
                </a-card>

                <!-- 계측기 관리 -->
                <a-card title="계측기 관리" :bordered="false" style="margin-bottom: 16px;">
                    <div v-for="sub in measurementSubsections" :key="sub.key" style="margin-bottom: 20px;">
                        <div style="font-weight:600; padding:6px 12px; margin-bottom:8px; background:#f0f2f5; border-left:3px solid #1890ff;">
                            {{ sub.label }}
                        </div>
                        <!-- <div v-if="!viewMode" class="list-add-bar" style="margin-bottom:8px;">
                            <a-button type="dashed" block @click="addMeasurementSubItem(sub.key)">
                                <a-icon type="plus" /> 항목 추가
                            </a-button>
                            <a-checkbox v-model="copyOnAdd[sub.key]">값 복사</a-checkbox>
                        </div> -->
                        <a-table
                            :columns="measurementSubColumns"
                            :data-source="formData[sub.key]"
                            :pagination="false"
                            size="small"
                            bordered
                        >
                            <template slot="no" slot-scope="text, record, index">
                                {{ index + 1 }}
                            </template>
                            <template slot="checkItem" slot-scope="text, record">
                                <a-input v-model="record.checkItem" placeholder="점검항목" :disabled="viewMode" />
                            </template>
                            <template slot="standard" slot-scope="text, record">
                                <a-input v-model="record.standard" placeholder="기준" :disabled="viewMode" />
                            </template>
                            <template slot="unit" slot-scope="text, record">
                                <a-input v-model="record.unit" placeholder="단위" :disabled="viewMode" />
                            </template>
                            <template slot="action" slot-scope="text, record, index">
                                <a-button v-if="!viewMode" type="link" size="small" @click="removeMeasurementSubItem(sub.key, index)">
                                    <a-icon type="delete" />
                                </a-button>
                                <span v-else>-</span>
                            </template>
                        </a-table>
                        <div v-if="!viewMode" class="list-add-bar" style="margin-top:8px;">
                            <a-button type="dashed" block @click="addMeasurementSubItem(sub.key)">
                                <a-icon type="plus" /> 항목 추가
                            </a-button>
                            <a-checkbox v-model="copyOnAdd[sub.key]">값 복사</a-checkbox>
                        </div>
                    </div>
                </a-card>

                <!-- 가스세이버 관리 -->
                <a-card title="가스세이버 관리" :bordered="false" style="margin-bottom: 16px;">
                    <!-- <div v-if="!viewMode" class="list-add-bar" style="margin-bottom: 16px;">
                        <a-button type="dashed" block @click="addGasSaverItem">
                            <a-icon type="plus" /> 항목 추가
                        </a-button>
                        <a-checkbox v-model="copyOnAdd.gasSaver">값 복사</a-checkbox>
                    </div> -->
                    <a-table 
                        :columns="gasSaverColumns" 
                        :data-source="formData.gasSaver" 
                        :pagination="false"
                        size="small"
                        bordered
                    >
                        <template slot="no" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </template>
                        <template slot="managementNo" slot-scope="text, record">
                            <a-input v-model="record.managementNo" placeholder="관리번호" :disabled="viewMode" />
                        </template>
                        <template slot="checkItem" slot-scope="text, record">
                            <a-input v-model="record.checkItem" placeholder="점검항목" :disabled="viewMode" />
                        </template>
                        <template slot="standard" slot-scope="text, record">
                            <a-input v-model="record.standard" placeholder="기준" :disabled="viewMode" />
                        </template>
                        <template slot="action" slot-scope="text, record, index">
                            <a-button v-if="!viewMode" type="link" size="small" @click="removeGasSaverItem(index)">
                                <a-icon type="delete" />
                            </a-button>
                            <span v-else>-</span>
                        </template>
                    </a-table>
                    <div v-if="!viewMode" class="list-add-bar" style="margin-top: 16px;">
                        <a-button type="dashed" block @click="addGasSaverItem">
                            <a-icon type="plus" /> 항목 추가
                        </a-button>
                        <a-checkbox v-model="copyOnAdd.gasSaver">값 복사</a-checkbox>
                    </div>
                </a-card>

                <!-- 검사장치 관리 -->
                <a-card title="검사장치 관리" :bordered="false" style="margin-bottom: 16px;">
                    <!-- <div v-if="!viewMode" class="list-add-bar" style="margin-bottom: 16px;">
                        <a-button type="dashed" block @click="addInspectionItem">
                            <a-icon type="plus" /> 항목 추가
                        </a-button>
                        <a-checkbox v-model="copyOnAdd.inspection">값 복사</a-checkbox>
                    </div> -->
                    <a-table 
                        :columns="inspectionColumns" 
                        :data-source="formData.inspection" 
                        :pagination="false"
                        size="small"
                        bordered
                    >
                        <template slot="no" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </template>
                        <template slot="equipmentName" slot-scope="text, record">
                            <a-input v-model="record.equipmentName" placeholder="장비명" :disabled="viewMode" />
                        </template>
                        <template slot="checkItem" slot-scope="text, record">
                            <a-input v-model="record.checkItem" placeholder="점검항목" :disabled="viewMode" />
                        </template>
                        <template slot="standard" slot-scope="text, record">
                            <a-input v-model="record.standard" placeholder="기준" :disabled="viewMode" />
                        </template>
                        <template slot="action" slot-scope="text, record, index">
                            <a-button v-if="!viewMode" type="link" size="small" @click="removeInspectionItem(index)">
                                <a-icon type="delete" />
                            </a-button>
                            <span v-else>-</span>
                        </template>
                    </a-table>
                    <div v-if="!viewMode" class="list-add-bar" style="margin-top: 16px;">
                        <a-button type="dashed" block @click="addInspectionItem">
                            <a-icon type="plus" /> 항목 추가
                        </a-button>
                        <a-checkbox v-model="copyOnAdd.inspection">값 복사</a-checkbox>
                    </div>
                </a-card>

                <!-- GAS 충진 M/C -->
                <a-card title="GAS 충진 M/C (제습기, 정수기)" :bordered="false" style="margin-bottom: 16px;">
                    <a-form-item label="사용 대상" style="margin-bottom: 0;">
                        <a-checkbox-group
                            v-model="formData.gasFillingTargets"
                            :disabled="viewMode"
                            :options="gasFillingTargetOptions"
                        />
                    </a-form-item>
                </a-card>

                <a-divider />
                <div style="text-align: center;">
                    <a-button @click="handleModalCancel" style="margin-right: 8px;">{{ viewMode ? '닫기' : '취소' }}</a-button>
                    <template v-if="!viewMode">
                        <a-button type="default" @click="handleSaveTemp" style="margin-right: 8px;">임시저장</a-button>
                        <a-button type="primary" @click="handleSaveComplete">저장완료</a-button>
                    </template>
                </div>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
import PageHeader from "../components/PageHeader.vue";

const columns = [
    { title: '상태', dataIndex: 'tag', key: 'tag', scopedSlots: { customRender: 'tags' }, width: 100 },
    { title: '템플릿명', dataIndex: 'name', key: 'name', scopedSlots: { customRender: 'name' } },
    { title: '라인명', dataIndex: 'lineName', key: 'lineName' },
    { title: '최종수정일', dataIndex: 'updated', key: 'updated' },
    { title: '관리', key: 'action', scopedSlots: { customRender: 'action' }, width: 320 },
];

const driverTorqueColumns = [
    { title: 'No', key: 'no', scopedSlots: { customRender: 'no' }, width: 60 },
    { title: '공정명', key: 'processName', scopedSlots: { customRender: 'processName' }, width: 150 },
    { title: '공구분류', key: 'toolType', scopedSlots: { customRender: 'toolType' }, width: 120 },
    { title: '관리번호', key: 'managementNo', scopedSlots: { customRender: 'managementNo' }, width: 150 },
    { title: '기준', key: 'standard', scopedSlots: { customRender: 'standard' } },
    { title: '삭제', key: 'action', scopedSlots: { customRender: 'action' }, width: 80 },
];

const GAS_FILLING_CATEGORY = 'GAS 충진 M/C';
const GAS_FILLING_TARGETS = ['제습기', '정수기'];
const GAS_FILLING_SHIFTS = ['오전', '오후', '잔업'];

const MEASUREMENT_SUBSECTIONS = [
    { key: 'msmt_cg_nv',  category: '청정기, 가습기', equipment: '내전압시험기',    label: '계측기 관리(청정기, 가습기) - 내전압시험기' },
    { key: 'msmt_cg_gj',  category: '청정기, 가습기', equipment: '접지연속성시험기', label: '계측기 관리(청정기, 가습기) - 접지연속성시험기' },
    { key: 'msmt_jsu_nv', category: '정수기',         equipment: '내전압시험기',    label: '계측기 관리(정수기) - 내전압시험기' },
    { key: 'msmt_jsu_gj', category: '정수기',         equipment: '접지연속성시험기', label: '계측기 관리(정수기) - 접지연속성시험기' },
];

const measurementSubColumns = [
    { title: 'No', key: 'no', scopedSlots: { customRender: 'no' }, width: 60 },
    { title: '점검항목', key: 'checkItem', scopedSlots: { customRender: 'checkItem' } },
    { title: '기준', key: 'standard', scopedSlots: { customRender: 'standard' }, width: 200 },
    { title: '단위', key: 'unit', scopedSlots: { customRender: 'unit' }, width: 100 },
    { title: '삭제', key: 'action', scopedSlots: { customRender: 'action' }, width: 80 },
];

const gasSaverColumns = [
    { title: 'No', key: 'no', scopedSlots: { customRender: 'no' }, width: 60 },
    { title: '관리번호', key: 'managementNo', scopedSlots: { customRender: 'managementNo' }, width: 150 },
    { title: '점검항목', key: 'checkItem', scopedSlots: { customRender: 'checkItem' } },
    { title: '기준', key: 'standard', scopedSlots: { customRender: 'standard' } },
    { title: '삭제', key: 'action', scopedSlots: { customRender: 'action' }, width: 80 },
];

const inspectionColumns = [
    { title: 'No', key: 'no', scopedSlots: { customRender: 'no' }, width: 60 },
    { title: '장비명', key: 'equipmentName', scopedSlots: { customRender: 'equipmentName' }, width: 200 },
    { title: '점검항목', key: 'checkItem', scopedSlots: { customRender: 'checkItem' } },
    { title: '기준', key: 'standard', scopedSlots: { customRender: 'standard' } },
    { title: '삭제', key: 'action', scopedSlots: { customRender: 'action' }, width: 80 },
];

export default {
    name: 'ToolTemplateRegister',
    components: {
        PageHeader,
    },
    data() {
        return {
            flagSpinner: false,
            filterState: '모두',
            filterCS: '',
            validRate: 100,
            columns,
            driverTorqueColumns,
            measurementSubColumns,
            measurementSubsections: MEASUREMENT_SUBSECTIONS,
            gasSaverColumns,
            inspectionColumns,
            gasFillingTargetOptions: GAS_FILLING_TARGETS.map(target => ({ label: target, value: target })),
            data: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            },
            isCreateModalVisible: false,
            viewMode: false,
            copyMode: false,
            editingSeq: null,
            copyOnAdd: {
                driverTorque: false,
                msmt_cg_nv: false,
                msmt_cg_gj: false,
                msmt_jsu_nv: false,
                msmt_jsu_gj: false,
                gasSaver: false,
                inspection: false,
            },
            form: this.$form.createForm(this),
            formData: {
                basicInfo: {
                    templateName: '',
                    date: '',
                    lineName: '',
                    writer: '',
                    productModel: ''
                },
                driverTorque: [],
                msmt_cg_nv: [],
                msmt_cg_gj: [],
                msmt_jsu_nv: [],
                msmt_jsu_gj: [],
                gasFillingTargets: [],
                gasSaver: [],
                inspection: []
            }
        };
    },
    mounted() {
        this.fetchTemplateList();
    },
    computed: {
        modalTitle() {
            if (this.viewMode) return '치공구 점검 템플릿 상세보기';
            if (this.copyMode) return '치공구 점검 템플릿 복사생성';
            if (this.editingSeq) return '치공구 점검 템플릿 수정';
            return '치공구 점검 템플릿 생성';
        },
    },
    methods: {
        getCurrentDateTime() {
            const now = new Date();
            const pad = n => String(n).padStart(2, '0');
            return `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
        },
        fetchTemplateList() {
            this.flagSpinner = true;
            const page = this.pagination.current - 1;
            const size = this.pagination.pageSize;
            let url = `${this.$store.state.nodeApiUrl}/tool/template/list?size=${size}&page=${page}`;
            
            if (this.filterState === '등록중') {
                url += '&state=TL_A';
            } else if (this.filterState === '등록완료') {
                url += '&state=TL_B';
            }
            
            if (this.filterCS) {
                url += `&name=${encodeURIComponent(this.filterCS)}`;
            }
            
            this.$http.get(url)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.pagination.total = response.data.data.totalElements || 0;
                        this.data = response.data.data.content.map(item => ({
                            key: item.productCsSeq,
                            tag: item.state === 'TL_A' ? '등록중' : '등록완료',
                            name: item.name,
                            lineName: item.line,
                            productModel: item.productModel || '-',
                            updated: item.updated
                        }));
                    }
                    this.flagSpinner = false;
                })
                .catch((error) => {
                    console.error(error);
                    this.$message.error('목록 조회에 실패했습니다.');
                    this.flagSpinner = false;
                });
        },
        changeFilterState(state) {
            this.filterState = state;
            this.filterCSList();
        },
        filterCSList() {
            this.pagination.current = 1;
            this.fetchTemplateList();
        },
        resetCSList() {
            this.filterCS = '';
            this.filterState = '모두';
            this.pagination.current = 1;
            this.fetchTemplateList();
        },
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.fetchTemplateList();
        },
        showCreateModal() {
            this.viewMode = false;
            this.copyMode = false;
            this.resetFormData();
            this.formData.basicInfo.writer = sessionStorage.getItem('user_name') || '';
            this.formData.basicInfo.date = this.getCurrentDateTime();
            this.isCreateModalVisible = true;
        },
        handleModalCancel() {
            this.isCreateModalVisible = false;
            this.viewMode = false;
            this.copyMode = false;
            this.resetFormData();
        },
        resetFormData() {
            this.editingSeq = null;
            this.copyMode = false;
            this.copyOnAdd = {
                driverTorque: false,
                msmt_cg_nv: false,
                msmt_cg_gj: false,
                msmt_jsu_nv: false,
                msmt_jsu_gj: false,
                gasSaver: false,
                inspection: false,
            };
            this.formData = {
                basicInfo: {
                    templateName: '',
                    date: '',
                    lineName: '',
                    writer: '',
                    productModel: ''
                },
                driverTorque: [],
                msmt_cg_nv: [],
                msmt_cg_gj: [],
                msmt_jsu_nv: [],
                msmt_jsu_gj: [],
                gasFillingTargets: [],
                gasSaver: [],
                inspection: []
            };
        },
        hasAnyRowValue(row, fieldKeys) {
            return fieldKeys.some((key) => {
                const value = row[key];
                if (value == null) return false;
                return String(value).trim() !== '';
            });
        },
        pushListItem(list, template, fieldKeys, copyEnabled) {
            if (!list.length || !copyEnabled) {
                list.push({ ...template });
                return;
            }
            const prev = list[list.length - 1];
            if (!this.hasAnyRowValue(prev, fieldKeys)) {
                list.push({ ...template });
                return;
            }
            const item = { ...template };
            fieldKeys.forEach((key) => {
                item[key] = prev[key];
            });
            list.push(item);
        },
        addDriverTorqueItem() {
            this.pushListItem(
                this.formData.driverTorque,
                { processName: '', toolType: '에어', managementNo: '', standard: '' },
                ['processName', 'toolType', 'managementNo', 'standard'],
                this.copyOnAdd.driverTorque,
            );
        },
        removeDriverTorqueItem(index) {
            this.formData.driverTorque.splice(index, 1);
        },
        addMeasurementSubItem(key) {
            this.pushListItem(
                this.formData[key],
                { checkItem: '', standard: '', unit: '' },
                ['checkItem', 'standard', 'unit'],
                this.copyOnAdd[key],
            );
        },
        removeMeasurementSubItem(key, index) {
            this.formData[key].splice(index, 1);
        },
        addGasSaverItem() {
            this.pushListItem(
                this.formData.gasSaver,
                { managementNo: '', checkItem: '', standard: '' },
                ['managementNo', 'checkItem', 'standard'],
                this.copyOnAdd.gasSaver,
            );
        },
        removeGasSaverItem(index) {
            this.formData.gasSaver.splice(index, 1);
        },
        addInspectionItem() {
            this.pushListItem(
                this.formData.inspection,
                { equipmentName: '', checkItem: '', standard: '' },
                ['equipmentName', 'checkItem', 'standard'],
                this.copyOnAdd.inspection,
            );
        },
        removeInspectionItem(index) {
            this.formData.inspection.splice(index, 1);
        },
        loadTemplateIntoForm(data, { viewMode = false, editingSeq = null, copyMode = false } = {}) {
            this.viewMode = viewMode;
            this.copyMode = copyMode;
            this.editingSeq = editingSeq;

            this.formData.basicInfo.templateName = copyMode ? '' : (data.name || '');
            this.formData.basicInfo.date = copyMode ? this.getCurrentDateTime() : (data.created || '');
            this.formData.basicInfo.lineName = data.line || '';
            this.formData.basicInfo.writer = copyMode
                ? (sessionStorage.getItem('user_name') || '')
                : (data.manager || '');

            this.formData.driverTorque = [];
            MEASUREMENT_SUBSECTIONS.forEach(sub => { this.formData[sub.key] = []; });
            this.formData.gasFillingTargets = [];
            this.formData.gasSaver = [];
            this.formData.inspection = [];

            (data.items || []).forEach(item => {
                if (item.category === 'driver_torque') {
                    this.formData.driverTorque.push({
                        processName: item.processName,
                        toolType: item.toolType,
                        managementNo: item.managementNo,
                        standard: item.standard
                    });
                } else if (item.category === 'measurement') {
                    if (
                        item.categoryName === GAS_FILLING_CATEGORY &&
                        GAS_FILLING_TARGETS.includes(item.equipmentName)
                    ) {
                        if (!this.formData.gasFillingTargets.includes(item.equipmentName)) {
                            this.formData.gasFillingTargets.push(item.equipmentName);
                        }
                        return;
                    }
                    const sub = MEASUREMENT_SUBSECTIONS.find(
                        s => s.category === item.categoryName && s.equipment === item.equipmentName
                    );
                    if (sub) {
                        this.formData[sub.key].push({
                            checkItem: item.checkItem,
                            standard: item.standard,
                            unit: item.unit
                        });
                    }
                } else if (item.category === 'gas_saver') {
                    this.formData.gasSaver.push({
                        managementNo: item.managementNo,
                        checkItem: item.checkItem,
                        standard: item.standard
                    });
                } else if (item.category === 'inspection') {
                    this.formData.inspection.push({
                        equipmentName: item.equipmentName,
                        checkItem: item.checkItem,
                        standard: item.standard
                    });
                }
            });
        },
        fetchTemplateItem(key, onSuccess) {
            this.flagSpinner = true;
            return this.$http.get(`${this.$store.state.nodeApiUrl}/tool/template/item/${key}`)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        onSuccess(response.data.data);
                    } else {
                        this.$message.error('데이터 조회에 실패했습니다.');
                    }
                    this.flagSpinner = false;
                })
                .catch((error) => {
                    console.error(error);
                    this.$message.error('데이터 조회에 실패했습니다.');
                    this.flagSpinner = false;
                });
        },
        handleSaveTemp() {
            this.saveTemplate('TL_A');
        },
        handleSaveComplete() {
            this.saveTemplate('TL_B');
        },
        checkDuplicateTemplateName(name) {
            return new Promise((resolve) => {
                const url = `${this.$store.state.nodeApiUrl}/tool/template/list?size=1000&page=0&name=${encodeURIComponent(name)}`;
                this.$http.get(url)
                    .then((response) => {
                        if (response.status === 200 && response.data.code === 'success') {
                            const items = response.data.data.content || [];
                            const isDuplicate = items.some(item => {
                                if (!this.copyMode && this.editingSeq && item.productCsSeq === this.editingSeq) {
                                    return false;
                                }
                                return item.name === name;
                            });
                            resolve(isDuplicate);
                        } else {
                            resolve(false);
                        }
                    })
                    .catch(() => resolve(false));
            });
        },
        saveTemplate(state) {
            const templateName = this.formData.basicInfo.templateName || '치공구 점검 템플릿';
            this.flagSpinner = true;
            this.checkDuplicateTemplateName(templateName).then((isDuplicate) => {
                if (isDuplicate) {
                    this.$message.error(`'${templateName}' 템플릿명이 이미 존재합니다. 다른 이름을 입력해주세요.`);
                    this.flagSpinner = false;
                    return;
                }
                this.persistTemplate(state);
            });
        },
        persistTemplate(state) {
            const items = [];
            
            this.formData.driverTorque.forEach(item => {
                items.push({
                    category: 'driver_torque',
                    processName: item.processName,
                    toolType: item.toolType,
                    managementNo: item.managementNo,
                    standard: item.standard
                });
            });
            
            MEASUREMENT_SUBSECTIONS.forEach(sub => {
                this.formData[sub.key].forEach(item => {
                    items.push({
                        category: 'measurement',
                        categoryName: sub.category,
                        equipmentName: sub.equipment,
                        checkItem: item.checkItem,
                        standard: item.standard,
                        unit: item.unit
                    });
                });
            });

            this.formData.gasFillingTargets.forEach(target => {
                GAS_FILLING_SHIFTS.forEach(shift => {
                    items.push({
                        category: 'measurement',
                        categoryName: GAS_FILLING_CATEGORY,
                        equipmentName: target,
                        checkItem: shift,
                        standard: '',
                        unit: ''
                    });
                });
            });
            
            this.formData.gasSaver.forEach(item => {
                items.push({
                    category: 'gas_saver',
                    managementNo: item.managementNo,
                    checkItem: item.checkItem,
                    standard: item.standard
                });
            });
            
            this.formData.inspection.forEach(item => {
                items.push({
                    category: 'inspection',
                    equipmentName: item.equipmentName,
                    checkItem: item.checkItem,
                    standard: item.standard
                });
            });
            
            const postData = {
                name: this.formData.basicInfo.templateName || '치공구 점검 템플릿',
                state: state,
                lineName: this.formData.basicInfo.lineName,
                writer: this.formData.basicInfo.writer,
                creator: sessionStorage.getItem('user_name') || 'system',
                updater: sessionStorage.getItem('user_name') || 'system',
                items: items
            };
            
            this.flagSpinner = true;

            const isEdit = !!this.editingSeq;
            const url = isEdit
                ? `${this.$store.state.nodeApiUrl}/tool/template/update/${this.editingSeq}`
                : `${this.$store.state.nodeApiUrl}/tool/template/create`;
            const request = isEdit
                ? this.$http.put(url, postData)
                : this.$http.post(url, postData);

            request
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.$message.success(state === 'TL_A' ? '임시저장되었습니다.' : '저장되었습니다.');
                        this.handleModalCancel();
                        this.fetchTemplateList();
                    } else {
                        this.$message.error('저장에 실패했습니다.');
                    }
                    this.flagSpinner = false;
                })
                .catch((error) => {
                    console.error(error);
                    this.$message.error('저장에 실패했습니다.');
                    this.flagSpinner = false;
                });
        },
        handlerToEdit(key) {
            this.fetchTemplateItem(key, (data) => {
                this.loadTemplateIntoForm(data, { editingSeq: key });
                this.isCreateModalVisible = true;
            });
        },
        handlerToCopy(key) {
            this.fetchTemplateItem(key, (data) => {
                this.loadTemplateIntoForm(data, { copyMode: true, editingSeq: null });
                this.isCreateModalVisible = true;
            });
        },
        handlerToDelete(key) {
            this.$confirm({
                title: '삭제 확인',
                content: '정말 삭제하시겠습니까?',
                onOk: () => {
                    this.flagSpinner = true;
                    this.$http.delete(`${this.$store.state.nodeApiUrl}/tool/template/delete/${key}`)
                        .then((response) => {
                            if (response.status === 200 && response.data.code === 'success') {
                                this.$message.success('삭제되었습니다.');
                                this.fetchTemplateList();
                            }
                            this.flagSpinner = false;
                        })
                        .catch((error) => {
                            console.error(error);
                            this.$message.error('삭제에 실패했습니다.');
                            this.flagSpinner = false;
                        });
                }
            });
        },
        handlerToView(key) {
            this.fetchTemplateItem(key, (data) => {
                this.loadTemplateIntoForm(data, { viewMode: true, editingSeq: null });
                this.isCreateModalVisible = true;
            });
        }
    }
};
</script>

<style scoped>
.list-add-bar {
    display: flex;
    align-items: center;
    gap: 12px;
}
.list-add-bar .ant-btn {
    flex: 1;
}
.state-btn {
    font-weight: bold;
    padding: 2px 8px;
}
.state-btn.red {
    background-color: #ff4d4f;
    color: white;
}
.state-btn.green {
    background-color: #52c41a;
    color: white;
}
</style>
